import FileExplorer from 'components/global/FileExplorer/FileExplorer';
import SimpleCard from 'components/global/SimpleCard';
import { $detail, $view } from 'signals/global.signals';

const FounderRoomVault = () => (
  <SimpleCard>
    <FileExplorer
      folders={$detail.value.folders || []}
      isLoading={$view.value.isLoading}
      mode="view"
      onClickViewDocument={(document) => {
        window.open(document.url, '_blank');
      }}
    />
  </SimpleCard>
);

export default FounderRoomVault;
